import { render, staticRenderFns } from "./PickingMat.vue?vue&type=template&id=9dc4a1d2"
import script from "./PickingMat.vue?vue&type=script&lang=js"
export * from "./PickingMat.vue?vue&type=script&lang=js"
import style0 from "./PickingMat.vue?vue&type=style&index=0&id=9dc4a1d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports